import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const profileSettingsQuery = gql`
  query profile {
    profileData: getUserProfile {
      userProfile {
        id
        firstName: first_name
        lastName: last_name
        email
        phone
      }
      affiliate {
        status
        comission
        activatedAt: activated_at
        file
        currency
        region
        paypalAccount: paypal_account
      }
    }
  }
`

export const linkPaypalAccountMutation = graphql(
  gql`
    mutation linkPaypalAccount($code: String!) {
      linkPaypalAccount(code: $code) {
        status
        paypalAccount: paypal_account
      }
    }
  `,
  {
    name: 'linkPaypalAccount'
  }
)

export const unLinkPaypalAccountMutation = graphql(
  gql`
    mutation unLinkPaypalAccount {
      unLinkPaypalAccount {
        status
      }
    }
  `,
  {
    name: 'unLinkPaypalAccount'
  }
)

export const getPaypalAccountQuery = gql`
  query getPaypalAccount($code: String!) {
    paypalInfo: getPaypalAccount(code: $code) {
      email
      payerId: payer_id
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/AffiliateOptions/data.ts